import type {
  RegisterInput,
  Configuration,
  CreateUserInput,
  UpdateUserInput,
  ListUsersResponse,
} from '@repo/api-gw-sdk';
import {
  CreateUserApi,
  DeleteUserApi,
  ListUsersApi,
  RegisterApi,
  UpdateUserOverrideApi,
  UpdateViewerRoleApi,
  RefreshApi,
  GetViewerApi,
  AcceptMsaApi,
  LogoutApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/users';

export const users = (
  httpClient: HttpClient,
  config: Configuration,
  isDevOrTest: boolean
) => {
  const refreshApi = new RefreshApi(config);
  const registerApi = new RegisterApi(config);
  const listUsersApi = new ListUsersApi(config);
  const deleteUserApi = new DeleteUserApi(config);
  const createUserApi = new CreateUserApi(config);
  const updateUserApi = new UpdateUserOverrideApi(config);
  const updateViewerRoleApi = new UpdateViewerRoleApi(config);
  const getViewerApi = new GetViewerApi(config);
  const acceptMsaApi = new AcceptMsaApi(config);
  const logoutApi = new LogoutApi(config);

  return {
    useList: () =>
      httpClient.execute(
        () =>
          listUsersApi.listUsers().catch((err) => {
            if (isDevOrTest) {
              return {
                users: [],
                pagination: {
                  recordsCount: 0,
                },
              } satisfies ListUsersResponse;
            }

            throw err;
          }),
        baseUrl,
        ''
      ),
    create: (user: CreateUserInput) => createUserApi.createUser(user),
    update: (id: string, user: UpdateUserInput) =>
      updateUserApi.updateUserOverride(id, user),
    delete: (id: string) => deleteUserApi.deleteUser(id),
    register: (registerInput: RegisterInput) =>
      registerApi.register(registerInput),
    changeRole: (roleId: string) =>
      updateViewerRoleApi.updateViewerRole({ roleId: roleId }),
    refreshToken: (redirectUrl?: string) => refreshApi.refresh(redirectUrl),
    useViewer: (options?: { refreshInterval: number }) =>
      httpClient.executeWithConfig(
        getViewerApi.getViewer.bind(getViewerApi),
        baseUrl,
        '/viewer',
        options
      ),
    acceptMsa: () => acceptMsaApi.acceptMsa(),
    // Expires every session cookie server-side; the caller then redirects to
    // /login. The response body is unused.
    logout: () => logoutApi.logout(),
  };
};
